// C2wLayout.jsx
import { Outlet, useLocation } from 'react-router';
import { useState, useEffect } from 'react';
import C2wHome from '../../../pages/c2wHomePage/homeIndex';

const C2wLayout = () => {
  const location = useLocation();
  const [showHome, setShowHome] = useState(location.pathname === '/');

  useEffect(() => {
    setShowHome(location.pathname === '/');
  }, [location]);

  return (
    <>
      {/* Home stays mounted; we toggle visibility */}
      <div style={{ display: showHome ? 'block' : 'none'}}>
        <C2wHome />
      </div>

      {/* Nested route component like CourseDetails */}
      <Outlet />
    </>
  );
};

export default C2wLayout;
